import { Routes } from '@angular/router';
import { ProcessDetailsComponent } from './pages/process-details/process-details.component';
import { ProcessComponent } from './pages/process/process.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', component: ProcessComponent, title: 'Processos', canActivate: [authGuard] },
  {
    path: 'process-details/:id',
    component: ProcessDetailsComponent,
    title: 'Detalhes do processo',
    canActivate: [authGuard],
  },
  { path: '**', component: PageNotFoundComponent, title: 'Página não encontrada' },
];
